<template>
  <div class="full">
    <v-data-table
      :headers="tableHeaders"
      :loading="isLoading"
      :items="envelopes"
      :rows-per-page-items="pagination.rowsPerPageItems"
      :total-items="pagination.totalItems"
      :pagination.sync="pagination"
      class="elevation-1">
      <template slot="headers" slot-scope="props">
        <tr>
          <template v-for="header in props.headers">
            <th :key="header.text" class="text-xs-left">
              {{ header.text }}
            </th>
          </template>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr  @click="showDetails(props.item)" :class="selectedItemId === props.item.id ?'selectedrow' : ''">
          <td class="text-xs-left"></td>
          <td class="text-xs-left">{{ props.item.buyer.name }}<br/> <span class="smalltext greytext"> {{ props.item.buyer.country }}, {{ props.item.buyer.city }}</span></td>
          <td class="text-xs-left">{{ $formatNumber(props.item.requestedAmount) }}</td>
          <td class="text-xs-left">{{ $formatNumber(props.item.limit) }}</td>
          <td class="text-xs-left"><span :class="props.item.status.toLowerCase()"><p class="centerText"> {{ $toTitleCase(props.item.status)}}</p></span></td>
           <td v-if="isActionEnabled" class="text-xs-left btn-left">
                  <v-btn @click.stop v-if="canCancelEnvelope(props.item.status)" color="primary" small @click="cancelEnvelope(props.item.id)">{{$t('ICE.ListICE.CANCEL_ICE_BTN')}}</v-btn>
            </td>
        </tr>
      </template>
      <template slot="no-data">
        <div v-if="isLoading" class="text-xs-center">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else>
          <p class="centerText">{{ labels.emptyDataLabel }}</p>
        </div>
      </template>
      </v-data-table>
  </div>
</template>

<script>
export default {
  props: ['envelopes', 'isLoading', 'selectedItemId', 'tableHeaders', 'isActionEnabled', 'paginationData'],
  data () {
    return {
      labels: {
        emptyDataLabel: this.$t('Cover.ListCover.NO_DATA_AVAILABLE_DESC')
      }
    }
  },
  methods: {
    showDetails: function (value) {
      this.$emit('itemClicked', value)
    },
    canCancelEnvelope: function (status) {
      return status.toLowerCase() === 'assessing' || status.toLowerCase() === 'active'
    },
    cancelEnvelope: function (value) {
      this.$emit('cancelEnvelope', value)
    }
  },
  computed: {
    pagination: {
      get: function () {
        return this.paginationData
      },
      set: function (value) {
        this.paginationData = value
      }
    }
  },
  watch: {
    pagination: {
      async handler () {
        this.$emit('loadAllEnvelopes', this.pagination)
      }
    },
    deep: true
  }
}
</script>

<style>

</style>
